export const downloadCsv = (filename: string, text: string) => {
  const dataStr = 'data:text/csv;charset=utf-8,' + encodeURIComponent(text);
  const node = document.createElement('a');
  node.setAttribute('href', dataStr);
  node.setAttribute('download', filename + '.csv');
  document.body.appendChild(node);
  node.click();
  node.remove();
};
